<h1 class="p-4 text-4xl font-medium">Greentripper Climate Projects</h1>
<app-cards-list [cardslist]="cardsList" />
